import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import GroupReportsWrapper from "./GroupReportsWrapper.js";
import {
  generateOriginalValue,
  handleNumDisplay,
} from "../Reports/utils/ReportUtils";
import i18n from "../../modules/Auth/pages/i18n.js";
import { useTranslation } from "react-i18next";

function GroupPaymentGatewayReport(props) {
  const { t } = useTranslation();

  useEffect(() => {
    i18n.changeLanguage(props.selectedLanguage);
  }, [props.selectedLanguage]);

  const columns = [
    { field: "hotelId", headerName: `${t("Hotel ID")}`, dataType: "varchar", checkboxSelection: true, headerCheckboxSelection: true },
    { field: "hotelName", headerName: `${t("Hotel Name")}`, dataType: "varchar" },
    { field: "sfPaymentId", headerName: `${t("SF Payment ID")}`, dataType: "varchar" },
    { field: "userEmail", headerName: `${t("User Email")}`, dataType: "varchar" },
    { field: "tokenId", headerName: `${t("Token ID")}`, dataType: "varchar" },
    { field: "pgChargeId", headerName: `${t("PG Charge ID")}`, dataType: "varchar" },
    { field: "gateway", headerName: `${t("Gateway")}`, dataType: "varchar" },
    { field: "bookingId", headerName: `${t("Booking ID")}`, dataType: "varchar" },
    { field: "orderId", headerName: `${t("Order ID")}`, dataType: "varchar" },
    { field: "checkIn", headerName: `${t("Check-In")}`, dataType: "date" },
    { field: "checkOut", headerName: `${t("Check-Out")}`, dataType: "date" },
    {
      field: "refundAmount",
      headerName: `${t("Refund Amount")}`,
      dataType: "float",
      aggFunc: "sum",
      valueGetter: (params) => generateOriginalValue(params, "refundAmount"),
      valueFormatter: (params) => handleNumDisplay(params, "float"),
      pinnedRowValueFormatter: (params) => handleNumDisplay(params, "float"),
    },
    {
      field: "netAmount",
      headerName: `${t("Net Amount")}`,
      dataType: "float",
      aggFunc: "sum",
      valueGetter: (params) => generateOriginalValue(params, "netAmount"),
      valueFormatter: (params) => handleNumDisplay(params, "float"),
      pinnedRowValueFormatter: (params) => handleNumDisplay(params, "float"),
    },
    {
      field: "gatewayFee",
      headerName: `${t("Gateway Fee")}`,
      dataType: "float",
      aggFunc: "sum",
      valueGetter: (params) => generateOriginalValue(params, "gatewayFee"),
      valueFormatter: (params) => handleNumDisplay(params, "float"),
      pinnedRowValueFormatter: (params) => handleNumDisplay(params, "float"),
    },
    {
      field: "sfCommission",
      headerName: `${t("SF Commission")}`,
      dataType: "float",
      aggFunc: "sum",
      valueGetter: (params) => generateOriginalValue(params, "sfCommission"),
      valueFormatter: (params) => handleNumDisplay(params, "float"),
      pinnedRowValueFormatter: (params) => handleNumDisplay(params, "float"),
    },
    { field: "bookingSource", headerName: `${t("Booking Source")}`, dataType: "varchar" },
    { field: "bookingStatus", headerName: `${t("Booking Status")}`, dataType: "varchar" },
    { field: "customerName", headerName: `${t("Customer Name")}`, dataType: "varchar" },
    { field: "customerContact", headerName: `${t("Customer Contact")}`, dataType: "varchar" },
    { field: "customerEmail", headerName: `${t("Customer Email")}`, dataType: "varchar" },
    { field: "hotelIdRef", headerName: `${t("Hotel ID Ref")}`, dataType: "varchar" },
    {
      field: "amount",
      headerName: `${t("Amount")}`,
      dataType: "float",
      aggFunc: "sum",
      valueGetter: (params) => generateOriginalValue(params, "amount"),
      valueFormatter: (params) => handleNumDisplay(params, "float"),
      pinnedRowValueFormatter: (params) => handleNumDisplay(params, "float"),
    },
    { field: "currencyCode", headerName: `${t("Currency Code")}`, dataType: "varchar" },
    { field: "capturedTime", headerName: `${t("Captured Time")}`, dataType: "date" },
    { field: "logTimestamp", headerName: `${t("Log Timestamp")}`, dataType: "date" },
    { field: "paymentStatus", headerName: `${t("Payment Status")}`, dataType: "varchar" },
    { field: "roomIds", headerName: `${t("Room IDs")}`, dataType: "varchar" },
    { field: "paymentType", headerName: `${t("Payment Type")}`, dataType: "varchar" },
    { field: "paymentIssuer", headerName: `${t("Payment Issuer")}`, dataType: "varchar" },
    { field: "cardLast4", headerName: `${t("Card Last4")}`, dataType: "varchar" },
    {
      field: "transferAmount",
      headerName: `${t("Transfer Amount")}`,
      dataType: "float",
      aggFunc: "sum",
      valueGetter: (params) => generateOriginalValue(params, "transferAmount"),
      valueFormatter: (params) => handleNumDisplay(params, "float"),
      pinnedRowValueFormatter: (params) => handleNumDisplay(params, "float"),
    },
    { field: "settlementDate", headerName: `${t("Settlement Date")}`, dataType: "date" },
    { field: "transferStatus", headerName: `${t("Transfer Status")}`, dataType: "varchar" },
    { field: "approved", headerName: `${t("Approved")}`, dataType: "varchar" },
  ];

  const [pinnedRow, setPinnedRow] = useState(null);
  function createPinnedData(params) {
    const result = {};
    for (let i = 0; i < columns.length; i++) {
      if (["integer", "float"].includes(columns[i].dataType)) {
        result[columns[i].field] = 0;
      }
    }

    function updateVals(i) {
      Object.keys(result).forEach((field) => {
        result[field] += i[`original_${field}`];
      });
    }

    params.api.getSelectedRows().length === 0
      ? params.api.forEachNodeAfterFilter((row) => updateVals(row.data))
      : params.api.getSelectedRows().forEach((row) => updateVals(row));

    result.bookingId = "Total";
    setPinnedRow([result]);
    params.api.setPinnedBottomRowData([result]);
  }

  return (
    <GroupReportsWrapper
      reportName={`${t("Group Payment Gateway Report")}`}
      columns={columns}
      reportActualType={"groupPgReport"}
      enableDateTypeFilters={false}
      createPinnedData={createPinnedData}
      pinnedRow={pinnedRow}
      selectedLanguage={props.selectedLanguage}
    />
  );
}

function mapStateToProps(state) {
  return { data: state.auth.hotels[0] };
}
export default connect(mapStateToProps)(GroupPaymentGatewayReport);
